/**
 * Locale-aware relative time formatting using native Intl.RelativeTimeFormat.
 */
const TIME_UNITS = [
    { unit: 'day', seconds: 86400 },
    { unit: 'hour', seconds: 3600 },
    { unit: 'minute', seconds: 60 },
];
function findBestUnit(diffInSeconds) {
    const absDiff = Math.abs(diffInSeconds);
    for (const { unit, seconds } of TIME_UNITS) {
        if (absDiff >= seconds) {
            return { unit, value: Math.floor(diffInSeconds / seconds) };
        }
    }
    return { unit: 'second', value: diffInSeconds };
}
export function formatRelativeTime(isoString, language = 'en') {
    try {
        const date = new Date(isoString);
        const now = new Date();
        const diffInSeconds = Math.floor((date.getTime() - now.getTime()) / 1000);
        if (Math.abs(diffInSeconds) < 60) {
            return new Intl.RelativeTimeFormat(language, { numeric: 'auto' }).format(0, 'second');
        }
        const { unit, value } = findBestUnit(diffInSeconds);
        const rtf = new Intl.RelativeTimeFormat(language, { numeric: 'auto' });
        return rtf.format(value, unit);
    }
    catch {
        return isoString;
    }
}
